module.exports = __webpack_public_path__ + "img/logotext.b479f224.svg";